import { Typography } from 'antd'
import styled from 'styled-components'

import { TimeNotesDisplayBlock as TimeNotesDisplayBlockType } from '../../types/blueprint'
import {
  getDiffPeriod,
  getDuration,
} from '../CaptureBlocks/TimeNotesCaptureBlock'

import { useTimezonedDates } from '@/context/timezoneContext'

const List = styled.ul`
  list-style-position: inside;
  padding-left: 0;
`

const ListItem = styled.div`
  display: --ms-inline-grid;
  display: inline-grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 1rem;
  margin-bottom: 0.5rem;
`

type Props = {
  block: TimeNotesDisplayBlockType
}

export const TimeNotesDisplayBlock: React.FC<Props> = ({ block }) => {
  const { formatDateRangeString, formatDateString } = useTimezonedDates()

  const { captureRange, pickerType, value } = block

  if (!value?.length) return null

  const duration = getDuration(value, pickerType)
  const period = getDiffPeriod(pickerType)

  return (
    <>
      <List>
        {value?.map((timeNote, index) => (
          <li key={index}>
            <ListItem>
              <Typography.Text>
                {captureRange
                  ? formatDateRangeString({
                      date: timeNote.dateTime,
                      includeDate: pickerType !== 'time',
                      includeTime:
                        pickerType === 'dateTime' || pickerType === 'time',
                    })
                  : formatDateString({
                      date: timeNote.dateTime,
                      includeDate: pickerType !== 'time',
                      includeTime:
                        pickerType === 'dateTime' || pickerType === 'time',
                    })}
                {timeNote.note && ':'}&nbsp;&nbsp;
              </Typography.Text>
              <Typography.Text style={{ whiteSpace: 'pre-wrap' }}>
                {timeNote.note}
              </Typography.Text>
            </ListItem>
          </li>
        ))}
      </List>
      <Typography.Paragraph>
        Total: {duration > 0 && ` ${duration} ${period}`}
      </Typography.Paragraph>
    </>
  )
}
